import { jsx as _jsx } from "react/jsx-runtime";
import { SourcesMenuItemCometMcpSource } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuItemCometMcpSource.js';
import { SourcesMenuItemConnector } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuItemConnector.js';
import { SourcesMenuItemPremiumData } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuItemPremiumData.js';
import { SourcesMenuItemSource } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuItemSource.js';
import { isConnectorId } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
import { isCoreSourceType } from '#pplx/frontend/apps/ask/sources/coreSourcesConfig.js';
import { isCometMcpSourceType } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
import React, { useCallback } from 'react';
export const SourcesMenuItem = React.memo(function SourcesMenuItem({ source, enabled, onToggle, getIsSourceConnected, getSource, }) {
    const handleClickAttachmentSelectorTrigger = useCallback((e) => {
        // Normally, we do not need to do this because this should be handled by
        // the Menu component itself. However, there's something stealing the click
        // event before it reaches the Menu component when used inside the AskInput
        // so here we are, manually stopping propagation.
        e.stopPropagation();
    }, []);
    return (_jsx("div", { onClick: handleClickAttachmentSelectorTrigger, children: _jsx(SourcesMenuItemContent, { source: source, enabled: enabled, onToggle: onToggle, getIsSourceConnected: getIsSourceConnected, getSource: getSource }) }));
});
const SourcesMenuItemContent = ({ source, enabled, onToggle, getIsSourceConnected, getSource, }) => {
    const apiSource = getSource(source);
    if (apiSource && 'is_premium' in apiSource && apiSource.is_premium) {
        return _jsx(SourcesMenuItemPremiumData, { source: source, enabled: enabled, onToggle: onToggle });
    }
    // Check core sources first, since some sources are both
    // connectors and core sources. isCoreSourceAllowed is the source of truth
    if (isCoreSourceType(source)) {
        return (_jsx(SourcesMenuItemSource, { source: source, enabled: enabled, onToggle: onToggle, getIsSourceConnected: getIsSourceConnected, getSource: getSource }));
    }
    if (isConnectorId(source)) {
        return (_jsx(SourcesMenuItemConnector, { source: source, enabled: enabled, onToggle: onToggle, getIsSourceConnected: getIsSourceConnected }));
    }
    if (isCometMcpSourceType(source)) {
        return _jsx(SourcesMenuItemCometMcpSource, { source: source, enabled: enabled, onToggle: onToggle });
    }
    return (_jsx(SourcesMenuItemSource, { source: source, enabled: enabled, onToggle: onToggle, getIsSourceConnected: getIsSourceConnected, getSource: getSource }));
};
//# sourceMappingURL=SourcesMenuItem.js.map